module.exports = new __parcel__URL__("Logo-Facebook.b28b61b4.svg").toString();